<div class="conversation-list-wrapper chat-panel">
  @if (summaryService.loading) {
    <div class="loading-wrapper">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    @if (summaryService.length > 0) {
      <cdk-virtual-scroll-viewport itemSize="130" class="virtual-viewport">
        <div *cdkVirtualFor="let chat of summaryService" [cdkContextMenuTriggerFor]="cardMenu">
          <ng-template #cardMenu>
            <div class="card-menu" cdkMenu>
              <button cdkMenuItem (click)="markReadUnread(chat)">Mark as {{ chat.isUnread ? "Read" : "Unread" }}</button>
            </div>
          </ng-template>
          <app-conversation-card [cardInfo]="chat" [isSelected]="chat.isSelected" (click)="selectConversation($event, chat)"></app-conversation-card>
        </div>
      </cdk-virtual-scroll-viewport>
    } @else {
      <p class="no-chats">To start a conversation click New Chat.</p>
    }
  }


</div>
